import { Extension } from '@tiptap/core';
import { Plugin } from '@tiptap/pm/state';

type TableCellCommitEditTiptapExtensionOptions = {
    onCommitEdit: (event: KeyboardEvent) => void;
};

const TableCellCommitEditTiptapExtension = Extension.create<TableCellCommitEditTiptapExtensionOptions>({
    name: 'tableCellCommitEdit',

    addOptions() {
        return {
            onCommitEdit: () => {},
        };
    },

    addProseMirrorPlugins() {
        return [
            new Plugin({
                props: {
                    handleKeyDown: (_view, event) => {
                        if (event.key !== 'Enter') return false;
                        if (event.shiftKey || event.altKey || event.ctrlKey || event.metaKey || event.isComposing) {
                            return false;
                        }

                        // Suppress default enter key behaviour, and return control to the table cell editor
                        // to handle the enter key press (ie finish editing and move selection).
                        event.preventDefault();
                        event.stopPropagation();
                        this.options.onCommitEdit(event);

                        return true;
                    },
                },
            }),
        ];
    },
});

export default TableCellCommitEditTiptapExtension;
